module.exports = __webpack_public_path__ + "static/media/connection1.403f374d.svg";